<template>
    <vue-simple-header :left-part-size="leftPartSize" :right-part-size="rightPartSize" separation-mode="md"
                       v-bind="$attrs" :with-background="false">
        <span slot="headerTitle"><span class="group-page-header">{{ title || group.name }}</span></span>
        <!--        <span slot="headerLabel">-->
        <!--            Group created by-->
        <!--            <strong>-->
        <!--                <simple-link :target="group.creator"></simple-link>-->
        <!--            </strong>-->
        <!--            <span v-if="group.community">in Community-->
        <!--                <strong>-->
        <!--                    <simple-link :target="group.community"></simple-link>-->
        <!--                </strong>-->
        <!--            </span>-->
        <!--            <span v-else-if="group.owner">in-->
        <!--                <strong>-->
        <!--                    <simple-link :target="group.owner"></simple-link>-->
        <!--                </strong>'s Circle-->
        <!--            </span>-->
        <!--            on {{ group.created_date | gbdate }}-->
        <!--            <br>-->
        <!--            <i>{{ group.description | cutName(50) }}</i>-->
        <!--        </span>-->
        <span slot="panelRight">
                    <slot name="additionalButtons"></slot>
                    <vue-folder-button
                            v-if="viewer_state.can_invite"
                            tabindex="0"
                            aria-label="Invite Users"
                            icon-class="fa-user-plus"
                            text="Invite Users"
                            @click.native="inviteUsers"
                    ></vue-folder-button>
                    <vue-folder-button
                            :target="backUrl"
                            icon-class="fa-reply"
                            color="blue"
                            text="Back"
                            no-text-on-mobile
                    ></vue-folder-button>
                </span>
    </vue-simple-header>
</template>

<script>
    import BackButtonMixin from "../../../../vue/mixins/BackButtonMixin";
    import {mapGetters} from "vuex";

    export default {
        name: "GroupPageHeader",
        mixins: [BackButtonMixin],
        props: {
            leftPartSize: {
                required: false,
                default: 8,
                type: Number
            },
            rightPartSize: {
                required: false,
                default: 4,
                type: Number
            },
            title: {
                type: String,
                required: false
            }
        },
        computed: {
            ...mapGetters('groupPage', {group: 'group', viewer_state: 'viewer_state'})
        },
        methods: {
            inviteUsers() {
                this.$store.dispatch('groupPage/inviteUsers');
            },
        }
    };
</script>
<style lang="scss" scoped>
  @import "../commonStyle";
</style>
